var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-upload-alt 1",
    clipPath: "url(#clip0_4604_4876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.29 6.5263C14.1975 3.90047 11.6275 2.16797 8.75 2.16797C4.84417 2.16797 1.66667 5.34547 1.66667 9.2513C1.66667 9.71047 1.71083 10.1655 1.7975 10.6121C0.675 11.4721 0 12.8171 0 14.2513C0 16.778 1.86917 18.8346 4.16667 18.8346H13.75C17.1967 18.8346 20 16.0313 20 12.5846C20 9.69547 18.0467 7.2213 15.29 6.5263ZM13.75 17.168H4.16667C2.78833 17.168 1.66667 15.8596 1.66667 14.2513C1.66667 13.2005 2.23667 12.2263 3.15333 11.7088L3.72667 11.3846L3.54417 10.7513C3.40417 10.2663 3.33333 9.7613 3.33333 9.25047C3.33333 6.2638 5.76333 3.8338 8.75 3.8338C11.075 3.8338 13.1383 5.31214 13.8817 7.51297L14.04 7.98297L14.53 8.06714C16.7342 8.44547 18.3325 10.3446 18.3325 12.5838C18.3325 15.1105 16.2758 17.1671 13.7492 17.1671L13.75 17.168ZM11.1783 8.48964L13.9225 11.2338L12.7442 12.4121L10.8333 10.5013V15.5013H9.16667V10.5013L7.25583 12.4121L6.0775 11.2338L8.82167 8.48964C9.47083 7.84047 10.5292 7.84047 11.1783 8.48964Z",
    fill: "#3487F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4604_4876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bdcac7406153b5c634225e41066597aa.svg";
export { ForwardRef as ReactComponent };